<div class="db-websites-empty-dedicated-hosting" [ngClass]="{'with-border': !fromDialog}">
  <div class="db-websites-empty-dedicated-hosting__content">
    <h1>{{'text_successfullyPurchasedDedicatedHosting' | dbText}}</h1>
    <p class="mt10">{{'text_hereIsWhatYourPlanIncludes' | dbText}}</p>
    <div class="db-websites-empty-dedicated-hosting__plan-includes mt20">
      <ul>
        <li *ngFor="let info of planIncludes; let i = index" [ngClass]="{'mt8': i !== 0}">
          <img src="assets/images/icons/checkmark-blue.svg" class="mr8"/>
          <span [innerHTML]="info"></span>
        </li>
      </ul>
    </div>
    <div class="db-websites-empty-dedicated-hosting__next-steps mt27">
      <h2>{{'text_nextSteps' | dbText}}</h2>
      <p>{{'text_dedicatedAccountManagerWillContact' | dbText}}</p>
    </div>
    <p class="db-websites-empty-dedicated-hosting__immediate-assistance mt27"><b>{{'text_immediateAssistance' | dbText}}:</b> {{'text_forImmediateAssistanceOrInquire' | dbText}} <a class="ds-link-blue" (click)="openChat()">{{'text_liveChat' | dbText}}</a>.</p>
    <div class="text-right" *ngIf="!!fromDialog">
      <a class="ds-btn-blue mt30" (click)="close()"><span>{{'text_gotIt' | dbText}}</span></a>
    </div>
  </div>
</div>
